import React from 'react';
import {
  ErrorHandler,
  LoadingState,
  Drawer,
  StandardNotFoundErrorMessage,
} from '@common/components';
import { useQuery } from '@common/hooks';
import { WorksRateCardsByAssignmentTermQuery } from '@pay-bill/graphql/queries/billing-rates';
import { BillingRatesDrawerBody } from 'works/legacy/components/billing-rates-drawer/_billing-rates-drawer-body';

export const BillingRatesDrawer = ({
  open,
  onClose,
  termId,
}: {
  open: boolean;
  onClose: () => void;
  termId?: string;
}) => {
  const { data, error, loading } = useQuery(
    WorksRateCardsByAssignmentTermQuery,
    {
      skip: !termId,
      variables: {
        termId: termId || '',
      },
    }
  );

  const renderDrawerBody = () => {
    const content = data?.worksRateCardsByAssignmentTerm;

    if (loading) {
      return <LoadingState />;
    }

    if (error) {
      return <ErrorHandler log="BillingRatesDrawer" error={error} />;
    }

    if (!data) {
      return null;
    }

    if (!content) {
      return <StandardNotFoundErrorMessage />;
    }

    return (
      <BillingRatesDrawerBody
        assignmentTerm={content.assignmentTerm}
        worksRateCards={content.worksRateCards}
      />
    );
  };

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        className="BillingRatesDrawer"
        title="Billing Rates"
        size="lg"
      >
        {renderDrawerBody()}
      </Drawer>
    </>
  );
};
